import type { VariantProps } from 'class-variance-authority'
import * as React from 'react'
import { cva } from 'class-variance-authority'
import { clsx } from 'clsx'

const buttonVariants = cva(
  'ds-inline-flex ds-font-text ds-items-center ds-overflow-hidden ds-border-half ds-rounded-6 ds-border-white-400 ds-justify-center ds-whitespace-nowrap ds-transition-all ds-duration-200 hover:ds-shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)] ds-[&>*:last-child]:border-r-0',
  {
    variants: {
      variant: {
        disabled:
          'ds-bg-white-100 ds-border-white-600 ds-text-black-700 ds-cursor-not-allowed ds-[&_circle]:stroke-black-500',
        primary:
          'ds-border-white-400 ds-text-black-900 ds-[&_circle]:stroke-black-900',
      },
      size: {
        '32': 'ds-h-[32px] ds-rounded-[8px] ds-text-13',
        '36': 'ds-h-[36px] ds-rounded-[8px] ds-text-14',
      },
    },
    defaultVariants: {
      variant: 'primary',
      size: '32',
    },
  },
)

export interface ButtonGroupProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  // buttons: {
  //     children: React.ReactNode;
  //     disabled?: boolean;
  //     onClick?: () => void;
  // }[];
}

export interface SingleButtonItemProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  children: React.ReactNode
  showRightBorder?: boolean
}

export const ButtonGroupItem = ({
  children,
  showRightBorder = true,
  ...props
}: SingleButtonItemProps) => {
  return (
    <div
      className={clsx(
        'ds-flex ds-h-full ds-items-center ds-px-8 hover:ds-bg-white-100/50 [&:last-child]:ds-border-r-0',
        showRightBorder && 'ds-border-r-[.5px] ds-border-white-500',
      )}
    >
      {children}
    </div>
  )
}
const ButtonGroup = React.forwardRef<HTMLButtonElement, ButtonGroupProps>(
  ({ className, variant = 'primary', size, children, ...props }, ref) => {
    const Comp = 'button' as React.ElementType

    // Handle both single child and array of children
    const childrenArray = React.Children.toArray(children)
    if (!childrenArray.length) return null

    return (
      <Comp
        className={clsx(buttonVariants({ variant, size, className }))}
        ref={ref}
        {...props}
      >
        {React.Children.map(children, (child, index) => {
          if (!React.isValidElement(child)) return null

          return React.cloneElement(child, {
            ...child.props,
            showRightBorder: false,
            key: index,
          })
        })}
      </Comp>
    )
  },
)
ButtonGroup.displayName = 'ButtonGroup'

export { ButtonGroup, buttonVariants }
